var facturacionCLPrint = {
    data() {
        return {
            socketFacturacionCL: null,
            defaultUrlFacturacionCLPrint: 'ws://localhost:8005',
            successFullConnectionFacturacionCLPrint: false,
            listPrinterFacturacionCLPrint: [],
            indexSelectedPrinterFacturacionCLPrint: -1,
            printingFacturacionCL: false,
            lookingForPrinters: false
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        analyzeMessageFacturacionCLPrint(data) {
            this.lookingForPrinters = false
            switch (data.cmd[0]) {
                case 'getPrinters':
                    this.indexSelectedPrinterFacturacionCLPrint = -1
                    this.listPrinterFacturacionCLPrint = data.data
                    this.listPrinterFacturacionCLPrint.forEach((element, index) => {
                        if (element == localStorage.printerFacturacionCL) {
                            this.indexSelectedPrinterFacturacionCLPrint = index
                        }
                    });
                    if (this.indexSelectedPrinterFacturacionCLPrint == -1) {
                        localStorage.removeItem('printerFacturacionCL')
                    }
                    break;
                case 'ticketPrint':
                    console.log(data.data[0])
                    break;
                default:
                    console.info('analyzeMessageFacturacionCLPrint - Mensaje no codificado')
            }
            this.analyzeMessageFacturacionCLPrintLocal(data)
        },
        analyzeMessageFacturacionCLPrintLocal(data) {

        },
        changeSelectedPrinterFacturacionCLPrint() {
            localStorage.printerFacturacionCL = this.listPrinterFacturacionCLPrint[this.indexSelectedPrinterFacturacionCLPrint]
        },
        connectFacturacionCLPrint(defaultUrl = null) {
            if (!this.successFullConnectionFacturacionCLPrint) {
                this.defaultUrlFacturacionCLPrint = (defaultUrl != null) ? defaultUrl : this.defaultUrlFacturacionCLPrint
                try {
                    let socketFacturacionCL = (localStorage.socketFacturacionCL !== undefined) ? localStorage.socketFacturacionCL : 'localhost'
                    let webSocket = 'ws://' + socketFacturacionCL + ':8005'
                    console.log(webSocket)
                    this.socketFacturacionCL = new WebSocket(webSocket);

                    this.socketFacturacionCL.onopen = () => {
                        this.successFullConnectionFacturacionCLPrint = true
                        this.socketFacturacionCLOpenLocal()
                        this.getPrinterFacturacionCLPrint()
                    }

                    this.socketFacturacionCL.onclose = () => {
                        this.successFullConnectionFacturacionCLPrint = false
                        this.socketFacturacionCLCloseLocal()
                    }

                    this.socketFacturacionCL.onmessage = (msg) => {
                        let data = JSON.parse(msg.data)
                        this.analyzeMessageFacturacionCLPrint(data);
                    }

                } catch (exception) {
                    console.info('ERROR: ' + exception);
                }

                console.log(this.socketFacturacionCL)
            }
        },
        getElectronicTicket(tipodte, folio, toPrint = false, header = '', quantity = 1) {
            let url = this.apiBackend + 'facturacionCL/getElectronicTicket?tipodte=' + tipodte + '&folio=' + folio
            this.axios.get(url, { headers: this.headers })
                .then(response => {
                    if (response.data.Error === undefined) {
                        if (toPrint) {
                            console.group('Imprimiendo documento ' + folio);
                            header = (header != '') ? this.repeatCharacter(' ', 32 - parseInt(header.length / 2)) + '!!' + header + '!\n\n' : header
                            header += (header != '') ? this.repeatCharacter('#', 64) : header
                            let head = (header != '') ? header + '\n' + window.atob(response.data.Head) : window.atob(response.data.Head)
                            this.printFacturacionCL(window.btoa(head), response.data.TED, response.data.Foot, localStorage.printerFacturacionCL, quantity)
                            console.groupEnd()
                        }
                    } else {
                        alert(response.data.Error)
                    }
                    this.printingFacturacionCL = false
                })
                .catch(error => {
                    console.log(error)
                    this.printingFacturacionCL = false
                    console.groupEnd()
                })
        },
        getPrinterFacturacionCLPrint() {
            this.listPrinterFacturacionCLPrint = []
            this.lookingForPrinters = true
            try {
                if (this.socketFacturacionCL.readyState === 3) {
                } else {
                    this.socketFacturacionCL.send('getPrinters');
                }
            } catch (exception) {
                console.info('getPrinterFacturacionCLPrint - ERROR: ' + exception);
            }
        },
        initMixinFactutacionCLPrint() {
            this.connectFacturacionCLPrint()
        },
        messageErrorConetionProgramFacturacionCL() {
            this.lookingForPrinters = false
            let mensaje = 'No hay conexión con la aplicación de FacturacionCL'
            console.log(mensaje)
            alert(mensaje)
        },
        printFacturacionCL(head, ted, foot, printer, quantity = 1) {
            if (printer != undefined) {
                try {
                    if (this.socketFacturacionCL.readyState === 3) {
                        this.messageErrorConetionProgramFacturacionCL()
                    } else {
                        let ringType = 'UERGNDE3';
                        let openDrawer = 'Tk8=';
                        let printer64 = window.btoa(printer)

                        let ticket = head + '|' + ted + '|' + foot + '|' + printer64 + '|' + ringType + '|' + openDrawer;

                        for (let i = 0; i < quantity; i++) {
                            this.socketFacturacionCL.send(ticket);
                        }
                        console.info('printFacturacionCL - Ticket enviada a la impresora ' + printer);
                    }
                } catch (exception) {
                    console.info('printFacturacionCL - ERROR: ' + exception);
                }
            } else {
                alert('No hay una impresora seleccionada para las boletas')
                this.$refs.openModalSetingModule.click()
            }
        },
        socketFacturacionCLCloseLocal() {
            console.info('Conexion WebSocket Facturacion CL cerrada');
        },
        socketFacturacionCLOpenLocal() {
            console.info('WebSocket Fecturacion CL conectado!!!')
        },
        toPrintFacturacionCL(tipodte, folio, head = '', quantity = 1) {
            this.printingFacturacionCL = true
            this.getElectronicTicket(tipodte, folio, true, head, quantity)
        }
    },
    mounted() {
        this.initMixinFactutacionCLPrint();
    },
};

export default facturacionCLPrint;